var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pa-3",
      staticStyle: { position: "relative", height: "calc(100vh - 100px)" }
    },
    [
      _vm.coTicketLoader
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ticket-list" },
        [
          _c("list-condition", {
            attrs: { param: _vm.coSearchParameter },
            on: {
              "update:param": function($event) {
                _vm.coSearchParameter = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "base-infinity-loading",
            {
              attrs: {
                pagination: _vm.pagination,
                "default-container": false,
                activityStatus: _vm.activityStatus,
                parameter: { param: _vm.coSearchParameter, merge: true },
                source: _vm.ticketViewModels,
                "on-fetch": _vm.storeGetTickets,
                "reset-before-destroy": _vm.storeResetTickets,
                "set-loader-state": _vm.setListLoaderState
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(row) {
                    return [
                      _c("list-item", {
                        attrs: {
                          ticket: row.data,
                          "character-problems": _vm.characterProblemsTranslation
                        }
                      })
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "loader" }, [
                _c(
                  "div",
                  { staticClass: "mt-3 ml-5" },
                  _vm._l(3, function(n) {
                    return _c("ticket-list-loader", { key: n })
                  }),
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bde8c6c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde8c6c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/ticket-child-list/template.html
// module id = null
// module chunks = 